<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：マップ画面
 *
 * 作成者：2021/11/27 ノア）虞
 * 最終修正者：2022/01/19 ノア）虞
 *
 -->
<template>
  <div class="map-body">
    <!-- サイドバー -->
    <div
      class="map-slider"
      :class="{ allWidth: allShowType === SliderShowType.ALL, thumbWidth: allShowType === SliderShowType.HALF }"
    >
      <!-- all show -->
      <div class="map-left" v-if="allShowType === SliderShowType.ALL">
        <div class="icon-top">
          <div
            class="icon-left icon-lr"
            @click="onIconClick(TabType.CAR)"
            :class="{ 'beclick-icon': tabType === TabType.CAR }"
            v-tooltip="{
              content: `${$t('dynamicMap.managementTabTip', [managementTarget])}`,
              placement: 'bottom-start',
              delay: { show: 1000, hide: 0 }
            }"
          >
            <div>
              <div class="tab-icon"><tti-svg-icon icon-name="wo_040"></tti-svg-icon></div>
              <div class="tab-title">{{ managementTarget }}</div>
            </div>
          </div>
          <div
            class="icon-right icon-lr"
            @click="onIconClick(TabType.PLACE)"
            :class="{ 'beclick-icon': tabType === TabType.PLACE }"
            v-tooltip="{
              content: `${$t('dynamicMap.placeTabTip')}`,
              placement: 'bottom-start',
              delay: { show: 1000, hide: 0 }
            }"
          >
            <div>
              <div class="tab-icon"><tti-svg-icon icon-name="wo_042"></tti-svg-icon></div>
              <div class="tab-title">{{ $t('dynamicMap.location') }}</div>
            </div>
          </div>
        </div>
        <div class="input entry" v-if="tabType === TabType.CAR">
          <div class="displayTarget">{{ $t('dynamicMap.displayTarget') }}</div>
          <el-radio-group v-model="usageType" @change="onChangeUsage">
            <el-radio v-for="item in usageStatusList" :key="item.code" :label="item.code">
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </div>
        <div class="input">
          <el-form :model="searchForm" :rules="searchRules" ref="searchFormRef">
            <el-form-item prop="filterObjectValue" v-if="tabType === TabType.CAR">
              <el-input
                :placeholder="$t('dynamicMap.keyword')"
                @input="onFilterValue"
                v-model.trim="searchForm.filterObjectValue"
                v-tooltip="{
                  content: `${$t('dynamicMap.keywordTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              ></el-input>
            </el-form-item>
            <el-form-item prop="filterPlaceValue" v-if="tabType === TabType.PLACE">
              <el-input
                :placeholder="$t('dynamicMap.keyword')"
                @input="onFilterValue"
                v-model.trim="searchForm.filterPlaceValue"
                v-tooltip="{
                  content: `${$t('dynamicMap.keywordTip')}`,
                  placement: 'bottom-start',
                  delay: { show: 1000, hide: 0 }
                }"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 利用中管理対象 -->
        <div class="tree" v-if="tabType === TabType.CAR && usageType === UsageStatus.IN_USE">
          <div
            :class="{ 'mb-24': el.children && el.children.length > 0 }"
            v-for="(el, ind) in managementForPage"
            :key="el.businessOfficeId"
          >
            <div
              class="label-title"
              v-if="el.children && el.children.length > 0"
              @click="onTreeClick(TreeType.IN_USE_DATA, ind)"
            >
              <span class="expander">
                <span v-if="el.isShow"><tti-svg-icon icon-name="su_021"></tti-svg-icon></span>
                <span v-else><tti-svg-icon icon-name="su_022"></tti-svg-icon></span>
              </span>
              {{ el.businessOfficeName }}
            </div>
            <template v-for="(elChild, indChild) in el.children">
              <div
                v-if="el.isShow"
                :key="indChild"
                class="tree-content"
                :class="{ 'tree-beChoosed': selectedManagement === elChild.manageTargetId }"
                @click="onCarContentClick(elChild)"
              >
                <div class="title">
                  <div>{{ elChild.manageTargetName }}</div>
                  <div>
                    {{ getDefinitionName(operationStatusList, elChild.deviceStatus, { code: 'code', value: 'name' }) }}
                  </div>
                </div>
                <div>{{ elChild.manageTargetCode }}</div>
              </div>
            </template>
          </div>
        </div>
        <!-- 未利用管理対象 -->
        <div class="tree" v-if="tabType === TabType.CAR && usageType === UsageStatus.NO_USE">
          <div
            :class="{ 'mb-24': el.children && el.children.length > 0 }"
            v-for="(el, ind) in managementForPage"
            :key="el.businessOfficeId"
          >
            <div
              class="label-title"
              v-if="el.children && el.children.length > 0"
              @click="onTreeClick(TreeType.NO_USE_DATA, ind)"
            >
              <span class="expander">
                <span v-if="el.isShow"><tti-svg-icon icon-name="su_021"></tti-svg-icon></span>
                <span v-else><tti-svg-icon icon-name="su_022"></tti-svg-icon></span>
              </span>
              {{ el.businessOfficeName }}
            </div>
            <template v-for="(elChild, indChild) in el.children">
              <div
                v-if="el.isShow"
                :key="indChild"
                class="tree-content"
                :class="{ 'tree-beChoosed': selectedManagement === elChild.manageTargetId }"
                @click="onCarContentClick(elChild)"
              >
                <div class="title">
                  <div>{{ elChild.manageTargetName }}</div>
                  <div>
                    {{ getDefinitionName(operationStatusList, elChild.deviceStatus, { code: 'code', value: 'name' }) }}
                  </div>
                </div>
                <div>{{ elChild.manageTargetCode }}</div>
              </div>
            </template>
          </div>
          <!-- 未設置SigfoxID一覧 -->
          <div class="label-title" @click="onTreeClick(TreeType.UNINSTALLED)">
            <i v-if="uninstalledSigfoxIdData.isShow" class="el-icon-arrow-down"></i>
            <i v-else class="el-icon-arrow-right"></i>
            {{ $t('dynamicMap.uninstalled') }}
          </div>
          <template v-for="elChild in uninstalledSigfoxIdData.children">
            <div v-if="uninstalledSigfoxIdData.isShow" :key="elChild" class="tree-content">
              <div class="title">
                <div>{{ elChild }}</div>
              </div>
            </div>
          </template>
        </div>
        <!-- 管理場所 -->
        <div class="tree" v-if="tabType === TabType.PLACE">
          <div :class="{ 'mb-24': el.children && el.children.length > 0 }" v-for="(el, ind) in placeForPage" :key="ind">
            <div
              class="label-title"
              v-if="el.children && el.children.length > 0"
              @click="onTreeClick(TreeType.PLACE, ind)"
            >
              <span class="expander">
                <span v-if="el.isShow"><tti-svg-icon icon-name="su_021"></tti-svg-icon></span>
                <span v-else><tti-svg-icon icon-name="su_022"></tti-svg-icon></span>
              </span>
              {{ el.businessOfficeName }}
            </div>
            <template v-for="(elChild, indChild) in el.children">
              <div
                v-if="el.isShow"
                :key="indChild"
                class="tree-content"
                :class="{ 'tree-beChoosed': selectedPlace === elChild.id }"
                @click="onPlaceContentClick(elChild)"
              >
                <div>{{ elChild.managementPlaceName }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- half show -->
      <div class="map-left-half" v-else-if="allShowType === SliderShowType.HALF">
        <div class="icon-left-top">
          <div
            class="icon-t"
            @click="onAllShowClick"
            v-tooltip="{
              content: `${$t('dynamicMap.silderBarTip')}`,
              placement: 'bottom-start',
              delay: { show: 1000, hide: 0 }
            }"
          >
            <tti-svg-icon icon-name="he_001"></tti-svg-icon>
          </div>
          <div
            class="icon-t"
            @click="onIconClick(TabType.CAR)"
            :class="{ 'beclick-icon-t': tabType === TabType.CAR }"
            v-tooltip="{
              content: `${$t('dynamicMap.managementTabTip', [managementTarget])}`,
              placement: 'bottom-start',
              delay: { show: 1000, hide: 0 }
            }"
          >
            <tti-svg-icon icon-name="wo_040"></tti-svg-icon>
          </div>
          <div
            class="icon-t"
            @click="onIconClick(TabType.PLACE)"
            :class="{ 'beclick-icon-t': tabType === TabType.PLACE }"
            v-tooltip="{
              content: `${$t('dynamicMap.placeTabTip')}`,
              placement: 'bottom-start',
              delay: { show: 1000, hide: 0 }
            }"
          >
            <tti-svg-icon icon-name="wo_042"></tti-svg-icon>
          </div>
          <el-popover placement="right" width="300" :visible-arrow="false" trigger="click">
            <div class="input">
              <el-form :model="searchForm" :rules="searchRules" ref="searchFormRef">
                <el-form-item prop="filterObjectValue" v-if="tabType === TabType.CAR">
                  <el-input
                    :placeholder="$t('dynamicMap.keyword')"
                    v-model.trim="searchForm.filterObjectValue"
                    @input="onFilterValue"
                    v-tooltip="{
                      content: `${$t('dynamicMap.keywordTip')}`,
                      placement: 'bottom-start',
                      delay: { show: 1000, hide: 0 }
                    }"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="filterPlaceValue" v-if="tabType === TabType.PLACE">
                  <el-input
                    :placeholder="$t('dynamicMap.keyword')"
                    v-model.trim="searchForm.filterPlaceValue"
                    @input="onFilterValue"
                    v-tooltip="{
                      content: `${$t('dynamicMap.keywordTip')}`,
                      placement: 'bottom-start',
                      delay: { show: 1000, hide: 0 }
                    }"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="icon-t" slot="reference"><tti-svg-icon icon-name="su_016"></tti-svg-icon></div>
          </el-popover>
        </div>
        <!-- 利用中管理対象 -->
        <div v-if="tabType === TabType.CAR && usageType === UsageStatus.IN_USE">
          <div
            class="half-content"
            v-for="(ite, ind) in thumDataForPage"
            :key="ind"
            :class="{ 'halfTree-beChoosed': selectedManagement === ite.manageTargetId }"
            @click="onCarContentClick(ite)"
          >
            <div>{{ ite.manageTargetName }}</div>
            <div>{{ ite.manageTargetId }}</div>
          </div>
        </div>
        <!-- 未利用管理対象 -->
        <div v-if="tabType === TabType.CAR && usageType === UsageStatus.NO_USE">
          <div
            class="half-content"
            v-for="(ite, ind) in thumDataForPage"
            :key="ind"
            :class="{ 'halfTree-beChoosed': selectedManagement === ite.manageTargetId }"
            @click="onCarContentClick(ite)"
          >
            <div>{{ ite.manageTargetName }}</div>
            <div>{{ ite.manageTargetId }}</div>
          </div>
        </div>
        <!-- 管理場所 -->
        <div v-if="tabType === TabType.PLACE">
          <div
            class="half-content"
            v-for="(ite, ind) in thumPlaceDataForPage"
            :key="ind"
            :class="{ 'halfTree-beChoosed': selectedPlace === ite.id }"
            @click="onPlaceHalfTreeClick(ite)"
          >
            <div>{{ ite.managementPlaceName }}</div>
          </div>
        </div>
      </div>
      <div
        class="map-right"
        :class="{
          allMapRightLeft: allShowType === SliderShowType.ALL,
          thumbMapRightLeft: allShowType === SliderShowType.HALF
        }"
        @click="onChangeSlider"
      >
        <tti-svg-icon icon-name="su_037" iconWidth="12"></tti-svg-icon>
      </div>
    </div>
    <div class="map-content">
      <div class="map-head">
        <el-button
          class="btn-none"
          @click="onToLocus"
          :disabled="!selectedManagement"
          v-tooltip="{
            content: `${$t('dynamicMap.toLocsPageTip')}`,
            placement: 'bottom-start',
            delay: { show: 1000, hide: 0 }
          }"
          ><tti-svg-icon icon-name="wo_014" class="mr-6"></tti-svg-icon>{{ $t('buttons.trajectory')
          }}<tti-svg-icon icon-name="wo_035" class="ml-6"></tti-svg-icon
        ></el-button>
      </div>
      <!-- 地図 -->
      <div ref="mapContainer" class="zdc-map"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { groupBy, filter, cloneDeep, toNumber, reverse } from 'lodash'

import { MapService } from '@/commons/services/mapService'
import {
  General,
  DynamicTargetParam,
  ManagementItem,
  ManagementItemForPage,
  ManagementPlaceMapData,
  PlaceMasterItemForPage,
  AllocationOfficeItem,
  DynamicPlaceParam,
  AreaMasterData,
  PrefectureMasterData
} from '@/models'
import config from '@/config/config'
import { localService } from '@/commons/services/localService'
import { i18n } from '@/locales'
import { RULES, validateService } from '@/service/validateService'
import { generalService, GeneralType } from '@/commons/services/generalService'
import {
  getDynamicTargetData,
  getDynamicPlaceData,
  getDynamicPlaceDtlData,
  getSalesOfficeAllocationMasterData,
  getAreaAllocationMasterData
} from '@/store/apis'
import { common } from '@/store/modules'
import { UsageStatus } from '@/commons/constants'
import HelperService from '@/service/helperService'

/**
 * タブタイプ定数
 *
 * @readonly
 * @constant
 */
enum TabType {
  CAR = 'car',
  PLACE = 'place'
}

/**
 * treeタイプ定数
 *
 * @readonly
 * @constant
 */
enum TreeType {
  IN_USE_DATA = 'inUseData',
  NO_USE_DATA = 'noUseData',
  UNINSTALLED = 'uninstalled',
  PLACE = 'place'
}

/**
 * サイドバー表示種別定数
 *
 * @readonly
 * @constant
 */
const SliderShowType = {
  ALL: 'all',
  HALF: 'half',
  NONE: 'none'
}

@Component({
  name: 'ttimap',
  components: {}
})
export default class TTIMAP extends Vue {
  /**
   * 利用状況
   *
   * @readonly
   * @constant
   */
  UsageStatus = UsageStatus

  /**
   * 地図サービス
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapService: any

  /**
   * 検索フォームのref
   */
  @Ref() readonly searchFormRef!: Form

  /**
   * タブタイプ定数
   */
  TabType = TabType

  /**
   * treeタイプ定数
   */
  TreeType = TreeType

  /**
   * サイドバー表示種別定数
   */
  SliderShowType = SliderShowType

  /**
   * タブタイプ
   */
  tabType = TabType.CAR

  /**
   * 選択した管理対象
   */
  selectedManagement = ''

  /**
   * 選択した管理場所
   */
  selectedPlace = ''

  /**
   * 営業所マスタ
   */
  officeMasterData: AllocationOfficeItem[] = []

  /**
   * 検索情報
   */
  searchForm = {
    filterObjectValue: '', // 管理対象フィルタのキーワード
    filterPlaceValue: '' // 管理場所フィルタのキーワード
  }

  /**
   * サイドバー表示種別
   */
  allShowType = SliderShowType.ALL

  /**
   * 稼働状況リスト
   */
  operationStatusList: General[] = []

  /**
   * 節電モードリスト
   */
  powerSavingModeList: General[] = []

  /**
   * 利用状況リスト
   */
  usageStatusList: General[] = []

  /**
   * 管理対象
   */
  managementTarget = localService.userInfo?.managementTargetShowName || i18n.t('commons.managementTarget')

  /**
   * 気に入り営業所
   *
   * @returns {string[]} 気に入り営業所
   */
  get watchedFavOfficeList(): string[] {
    return common.favOfficeList
  }

  /**
   * キーワード入力検証ルール
   */
  searchRules: Form['rules'] = {
    filterObjectValue: [
      // 50文字以内
      {
        validator: validateService.getValidator([
          {
            rule: RULES.MAXLENGTH,
            number: 50,
            message: i18n.t('vaildate.common.maxlength', [i18n.t('dynamicMap.keyword'), 50]).toString()
          }
        ]),
        trigger: 'blur'
      }
    ],
    filterPlaceValue: [
      // 50文字以内
      {
        validator: validateService.getValidator([
          {
            rule: RULES.MAXLENGTH,
            number: 50,
            message: i18n.t('vaildate.common.maxlength', [i18n.t('dynamicMap.keyword'), 50]).toString()
          }
        ]),
        trigger: 'blur'
      }
    ]
  }

  /**
   * 利用中管理対象データ
   */
  managementInUseData: ManagementItemForPage[] = []

  /**
   * 未利用管理対象データ
   */
  managementNoUseData: ManagementItemForPage[] = []

  /**
   * 管理場所データ
   */
  managementPlaceData: PlaceMasterItemForPage[] = []

  /**
   * 未設置SigfoxID一覧
   */
  uninstalledSigfoxIdData: { isShow: boolean; children: string[] } = {
    isShow: true,
    children: []
  }

  getDefinitionName = HelperService.getDefinitionName

  /**
   * サムネイルメニュー車利用中管理対象データ
   */
  thumInUseData: ManagementItem[] = []

  /**
   * サムネイルメニュー未利用管理対象データ
   */
  thumNoUseData: ManagementItem[] = []

  /**
   * サムネイルメニュー地点データ
   */
  thumPlaceData: ManagementPlaceMapData[] = []

  /**
   * 管理対象データ画面用
   */
  managementForPage: ManagementItemForPage[] = []

  /**
   * 管理場所データ画面用
   */
  placeForPage: PlaceMasterItemForPage[] = []

  /**
   * サムネイルメニュー管理対象データ画面用
   */
  thumDataForPage: ManagementItem[] = []

  /**
   * サムネイルメニュー地点データ画面用
   */
  thumPlaceDataForPage: ManagementPlaceMapData[] = []

  /**
   * 選択した利用状況
   */
  usageType = UsageStatus.IN_USE

  /**
   * エリア割当リスト
   */
  areaAllocationMasterData: AreaMasterData[] = []

  /**
   * 管理場所一覧
   */
  theDynamicPlaceList: ManagementPlaceMapData[] = []

  /**
   * 気に入り営業所
   */
  favOfficeList: string[] = []

  /**
   * 動態管理対象一覧
   */
  theDynamicTargetList: ManagementItem[] = []

  /**
   * mqtt管理対象
   *
   * @returns {ManagementItem} mqtt管理対象
   */
  get watchedDynamicMqttData(): ManagementItem | null {
    return common.dynamicMqttData ? common.dynamicMqttData : null
  }

  /**
   * mqtt管理対象変更した時の処理
   *
   * @param {ManagementItem} value  mqtt管理対象
   * @returns {void}
   */
  // eslint-disable-next-line
  @Watch('watchedDynamicMqttData', { immediate: true, deep: true })
  onDynamicMqttDataChange(value: ManagementItem): void {
    if (!value) {
      return
    }
    if (!this.favOfficeList.includes(value.businessOfficeId)) {
      return
    }

    const resultValue = cloneDeep(value)
    resultValue.deviceStatusName = this.getDefinitionName(this.operationStatusList, resultValue.deviceStatus, {
      code: 'code',
      value: 'name'
    })
    resultValue.powerSavingModeName = this.getDefinitionName(this.powerSavingModeList, resultValue.powerSavingMode, {
      code: 'code',
      value: 'name'
    })
    resultValue.latForPage = this.formatLatlonShow(resultValue.lat as string)
    resultValue.lat = HelperService.dmToDeg(resultValue.lat as string)
    resultValue.lngForPage = this.formatLatlonShow(resultValue.lng as string)
    resultValue.lng = HelperService.dmToDeg(resultValue.lng as string)
    let mapObject
    let isMatchedManagement = false

    this.theDynamicTargetList.forEach((item, index) => {
      if (item.manageTargetId === resultValue.manageTargetId) {
        isMatchedManagement = true
        if (!resultValue.lat || !resultValue.lng) {
          resultValue.lat = this.theDynamicTargetList[index].lat
          resultValue.latForPage = this.theDynamicTargetList[index].latForPage
          resultValue.lng = this.theDynamicTargetList[index].lng
          resultValue.lngForPage = this.theDynamicTargetList[index].lngForPage
          resultValue.location = this.theDynamicTargetList[index].location
        }
        this.theDynamicTargetList[index] = Object.assign(item, resultValue)
        mapObject = cloneDeep(this.theDynamicTargetList[index])
      }
    })

    if (!isMatchedManagement) {
      this.theDynamicTargetList.push(resultValue)
      mapObject = cloneDeep(resultValue)
    }

    this.mapService.getDynamicTargetList(this.theDynamicTargetList)

    const sigfoxIndex = this.uninstalledSigfoxIdData.children.indexOf(resultValue.sigfoxId)
    if (sigfoxIndex > -1) {
      this.uninstalledSigfoxIdData.children.splice(sigfoxIndex, 1)
    }

    this.managementInUseData = this.formatTargetList(this.theDynamicTargetList, UsageStatus.IN_USE)
    this.managementNoUseData = this.formatTargetList(this.theDynamicTargetList, UsageStatus.NO_USE)

    this.thumInUseData = []
    this.managementInUseData.forEach(ele => {
      if (ele.children && ele.children.length > 0) {
        ele.children.forEach(ite => {
          this.thumInUseData.push(ite)
        })
      }
    })
    this.thumNoUseData = []
    this.managementNoUseData.forEach(ele => {
      if (ele.children && ele.children.length > 0) {
        ele.children.forEach(ite => {
          this.thumNoUseData.push(ite)
        })
      }
    })

    if (mapObject) {
      if (mapObject.lat && mapObject.lng) {
        this.mapService.markObject(mapObject)
        this.mapService.markMessage(mapObject)
      }
    }

    this.initManagementData()
  }

  /**
   * 気に入り営業所変更した時の処理
   *
   * @param {string[]} value  気に入り営業所
   * @returns {void}
   */
  @Watch('watchedFavOfficeList', { deep: true })
  async onFavOfficeChange(value: string[]): Promise<void> {
    if (!value || value.length === 0) {
      return
    }

    this.favOfficeList = value

    const dynamicTargetParam = {
      businessOfficeIdList: value
    }
    const dynamicPlaceParam = {
      businessOfficeList: value
    }

    this.mapService = new MapService()

    const mapContainer = this.$refs.mapContainer
    if (!mapContainer) {
      return
    }

    this.mapService.init(mapContainer as HTMLDivElement)

    this.fetchDynamicTargetList(dynamicTargetParam)
    await this.fetchMasterPlaceList(dynamicPlaceParam)
    this.fetchMasterPlaceDtlList(dynamicPlaceParam)
  }

  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  async mounted(): Promise<void> {
    common.setSelectedManagementObject('')

    await Promise.all([
      this.fetchOperationStatus(),
      this.fetchUsageStatus(),
      this.fetchPowerSavingMode(),
      this.fetchAreaAllocationMasterData(),
      this.fetchSalesOfficeAllocationMaster()
    ])

    this.onFavOfficeChange(this.watchedFavOfficeList)
  }

  /**
   * インスタンスが破棄された後にフック処理
   *
   * @returns {void}
   */
  destroyed(): void {
    common.setSelectedManagementObject('')
  }

  /**
   * メニュータブオプションをクリック
   *
   * @param {TabType} type メニュータブ
   * @returns {void}
   */
  onIconClick(type: TabType): void {
    this.tabType = type
    this.initSelected()
  }

  initSelected(): void {
    this.selectedManagement = ''
    this.selectedPlace = ''
  }

  /**
   * ツリー構造データの切り替
   *
   * @param {TreeType} type メニュータブ
   * @param {number} index インデックス
   * @returns {void}
   */
  onTreeClick(type: TreeType, index = 0): void {
    switch (type) {
      case TreeType.IN_USE_DATA:
        this.managementInUseData[index].isShow = !this.managementInUseData[index].isShow
        this.managementForPage[index].isShow = !this.managementForPage[index].isShow
        break

      case TreeType.NO_USE_DATA:
        this.managementNoUseData[index].isShow = !this.managementNoUseData[index].isShow
        this.managementForPage[index].isShow = !this.managementForPage[index].isShow
        break

      case TreeType.UNINSTALLED:
        this.uninstalledSigfoxIdData.isShow = !this.uninstalledSigfoxIdData.isShow
        break

      case TreeType.PLACE:
        this.managementPlaceData[index].isShow = !this.managementPlaceData[index].isShow
        this.placeForPage[index].isShow = !this.placeForPage[index].isShow
        break

      default:
        break
    }
  }

  /**
   * 車両データを選択
   *
   * @param {ManagementItem} elChild 車両データ
   * @returns {void}
   */
  onCarContentClick(elChild: ManagementItem): void {
    if (!elChild.lat || !elChild.lng) {
      this.mapService.closeAllDialog()
      return
    }
    this.selectedManagement = elChild.manageTargetId
    common.setSelectedManagementObject(this.selectedManagement)
    this.mapService.closeAllDialog()
    this.mapService.openObjectDialog(elChild, true)
  }

  /**
   * 地点データを選択
   *
   * @param {ManagementPlaceMapData} elChild 地点データ
   * @returns {void}
   */
  onPlaceContentClick(elChild: ManagementPlaceMapData): void {
    if (elChild.id) this.selectedPlace = elChild.id
    this.mapService.closeAllDialog()
    this.mapService.openPlaceDialog(elChild, true)
  }

  /**
   * メニュー表示の切り替
   *
   * @returns {void}
   */
  onChangeSlider(): void {
    switch (this.allShowType) {
      case SliderShowType.ALL:
        this.allShowType = SliderShowType.HALF
        break
      case SliderShowType.HALF:
        this.allShowType = SliderShowType.NONE
        break
      case SliderShowType.NONE:
        this.allShowType = SliderShowType.ALL
        break
      default:
        this.allShowType = SliderShowType.ALL
    }

    setTimeout(() => {
      this.mapService.mapRefresh()
    })
  }

  /**
   * メニュー全体を表示
   *
   * @returns {void}
   */
  onAllShowClick(): void {
    this.allShowType = SliderShowType.ALL
    setTimeout(() => {
      this.mapService.mapRefresh()
    })
  }

  /**
   * サムネイルメニューの地点データを選択
   *
   * @param {ManagementPlaceMapData} elChild サムネイルメニューの地点データ
   * @returns {void}
   */
  onPlaceHalfTreeClick(elChild: ManagementPlaceMapData): void {
    if (elChild.id) this.selectedPlace = elChild.id
    this.mapService.closeAllDialog()
    this.mapService.openPlaceDialog(elChild, true)
  }

  onToLocus(): void {
    this.$router.push({
      path: config.menu.locusDisplay,
      query: {
        managementTargetId: this.selectedManagement
      }
    })
  }

  /**
   * 稼働状況リストを取得する
   *
   * @returns {void}
   */
  async fetchOperationStatus(): Promise<void> {
    try {
      this.operationStatusList = await generalService[GeneralType.DEVICE_STATUS]
    } catch (e) {
      this.$log.debug('MAP > fetchOperationStatus: e=', e)
      throw e
    }
  }

  /**
   * 節電モードを取得する
   *
   * @returns {void}
   */
  async fetchPowerSavingMode(): Promise<void> {
    try {
      this.powerSavingModeList = await generalService[GeneralType.POWER_SAVING_MODE]
    } catch (e) {
      this.$log.debug('MAP > fetchOperationStatus: e=', e)
      throw e
    }
  }

  /**
   * 利用状況リストを取得する
   *
   * @returns {void}
   */
  async fetchUsageStatus(): Promise<void> {
    try {
      this.usageStatusList = await generalService[GeneralType.USAGE_STATUS]
      this.usageStatusList = reverse(this.usageStatusList)
    } catch (e) {
      this.$log.debug('MAP > fetchUsageStatus: e=', e)
      throw e
    }
  }

  /**
   * 動態管理対象一覧を取得する
   *
   * @param {DynamicTargetParam} dynamicTargetParam 動態管理対象のパラメータ
   * @returns {void}
   */
  // eslint-disable-next-line
  async fetchDynamicTargetList(dynamicTargetParam: DynamicTargetParam): Promise<void> {
    try {
      const dynamicTargetData = await getDynamicTargetData(dynamicTargetParam)
      const dynamicTargetList = dynamicTargetData.manageTargetList
      dynamicTargetList.map((item, index) => {
        dynamicTargetList[index].latForPage = this.formatLatlonShow(item.lat as string)
        dynamicTargetList[index].lat = HelperService.dmToDeg(item.lat as string)
        dynamicTargetList[index].lngForPage = this.formatLatlonShow(item.lng as string)
        dynamicTargetList[index].lng = HelperService.dmToDeg(item.lng as string)
      })
      this.theDynamicTargetList = cloneDeep(dynamicTargetList)
      this.mapService.getDynamicTargetList(dynamicTargetList)
      const firstTargetList = dynamicTargetList[0]
      if (firstTargetList && firstTargetList.lat && firstTargetList.lng) {
        const paramLatLon = { lat: firstTargetList.lat, lng: firstTargetList.lng }
        this.mapService.moveLatLon(paramLatLon)
      }
      this.uninstalledSigfoxIdData.children = dynamicTargetData.uninstalledSigfoxIdList
      this.managementInUseData = this.formatTargetList(dynamicTargetList, UsageStatus.IN_USE)
      this.managementNoUseData = this.formatTargetList(dynamicTargetList, UsageStatus.NO_USE)

      this.thumInUseData = []
      this.managementInUseData.forEach(ele => {
        if (ele.children && ele.children.length > 0) {
          ele.children.forEach(ite => {
            this.thumInUseData.push(ite)
            if (ite.lat && ite.lng) {
              this.mapService.markObject(ite)
              this.mapService.markMessage(ite)
            }
          })
        }
      })
      this.thumNoUseData = []
      this.managementNoUseData.forEach(ele => {
        if (ele.children && ele.children.length > 0) {
          ele.children.forEach(ite => {
            this.thumNoUseData.push(ite)
            if (ite.lat && ite.lng) {
              this.mapService.markObject(ite)
              this.mapService.markMessage(ite)
            }
          })
        }
      })

      this.initManagementData()
      this.$log.debug('MAP > fetchDynamicTargetList: dynamicTargetList=', dynamicTargetList)
    } catch (e) {
      this.$log.debug('MAP > fetchDynamicTargetList: e=', e)
      throw e
    }
  }

  /**
   * 管理場所一覧を取得する
   *
   * @param {DynamicPlaceParam} dynamicTargetParam 管理場所一覧のパラメータ
   * @returns {void}
   */
  // eslint-disable-next-line
  async fetchMasterPlaceList(dynamicTargetParam: DynamicPlaceParam): Promise<void> {
    try {
      const dynamicPlaceData = await getDynamicPlaceData(dynamicTargetParam)
      const dynamicPlaceList = dynamicPlaceData.list as ManagementPlaceMapData[]

      dynamicPlaceList.map((item, index) => {
        dynamicPlaceList[index].latUpperLeftForPage = HelperService.degToDm(item.latUpperLeft as string)
        dynamicPlaceList[index].latUpperLeftForPage = this.formatLatlonShow(
          dynamicPlaceList[index].latUpperLeftForPage as string
        )
        dynamicPlaceList[index].latUpperLeft = toNumber(item.latUpperLeft || 0)

        dynamicPlaceList[index].lngUpperLeftForPage = HelperService.degToDm(item.lngUpperLeft as string)
        dynamicPlaceList[index].lngUpperLeftForPage = this.formatLatlonShow(
          dynamicPlaceList[index].lngUpperLeftForPage as string
        )
        dynamicPlaceList[index].lngUpperLeft = toNumber(item.lngUpperLeft || 0)

        dynamicPlaceList[index].latUpperRightForPage = HelperService.degToDm(item.latUpperRight as string)
        dynamicPlaceList[index].latUpperRightForPage = this.formatLatlonShow(
          dynamicPlaceList[index].latUpperRightForPage as string
        )
        dynamicPlaceList[index].latUpperRight = toNumber(item.latUpperRight || 0)

        dynamicPlaceList[index].lngUpperRightForPage = HelperService.degToDm(item.lngUpperRight as string)
        dynamicPlaceList[index].lngUpperRightForPage = this.formatLatlonShow(
          dynamicPlaceList[index].lngUpperRightForPage as string
        )
        dynamicPlaceList[index].lngUpperRight = toNumber(item.lngUpperRight || 0)

        dynamicPlaceList[index].latLowerLeftForPage = HelperService.degToDm(item.latLowerLeft as string)
        dynamicPlaceList[index].latLowerLeftForPage = this.formatLatlonShow(
          dynamicPlaceList[index].latLowerLeftForPage as string
        )
        dynamicPlaceList[index].latLowerLeft = toNumber(item.latLowerLeft || 0)

        dynamicPlaceList[index].lngLowerLeftForPage = HelperService.degToDm(item.lngLowerLeft as string)
        dynamicPlaceList[index].lngLowerLeftForPage = this.formatLatlonShow(
          dynamicPlaceList[index].lngLowerLeftForPage as string
        )
        dynamicPlaceList[index].lngLowerLeft = toNumber(item.lngLowerLeft || 0)

        dynamicPlaceList[index].latLowerRightForPage = HelperService.degToDm(item.latLowerRight as string)
        dynamicPlaceList[index].latLowerRightForPage = this.formatLatlonShow(
          dynamicPlaceList[index].latLowerRightForPage as string
        )
        dynamicPlaceList[index].latLowerRight = toNumber(item.latLowerRight || 0)

        dynamicPlaceList[index].lngLowerRightForPage = HelperService.degToDm(item.lngLowerRight as string)
        dynamicPlaceList[index].lngLowerRightForPage = this.formatLatlonShow(
          dynamicPlaceList[index].lngLowerRightForPage as string
        )
        dynamicPlaceList[index].lngLowerRight = toNumber(item.lngLowerRight || 0)
      })

      this.theDynamicPlaceList = cloneDeep(dynamicPlaceList)

      this.formatPlaceListAfter(this.theDynamicPlaceList)

      this.$log.debug('MAP > fetchMasterPlaceList: dynamicPlaceData=', dynamicPlaceData)
    } catch (e) {
      this.$log.debug('MAP > fetchMasterPlaceList: e=', e)
      throw e
    }
  }

  /**
   * 管理場所データ変換された操作
   *
   * @param {ManagementPlaceMapData[]} dynamicPlaceList 管理場所データ
   */
  formatPlaceListAfter(dynamicPlaceList: ManagementPlaceMapData[]): void {
    this.managementPlaceData = this.formatPlaceList(dynamicPlaceList)

    this.thumPlaceData = []
    this.managementPlaceData.forEach(ele => {
      if (ele.children && ele.children.length > 0) {
        ele.children.forEach(ite => {
          this.thumPlaceData.push(ite)

          this.mapService.markPlace(ite)
          this.mapService.markPlaceMessage(ite)
          this.mapService.drawImage(ite)
        })
      }
    })

    this.initManagementPlaceData()
  }

  /**
   * 管理場所詳細一覧を取得する
   *
   * @param {DynamicPlaceParam} dynamicTargetParam 管理場所一覧のパラメータ
   * @returns {void}
   */
  async fetchMasterPlaceDtlList(dynamicTargetParam: DynamicPlaceParam): Promise<void> {
    try {
      const dynamicPlaceData = await getDynamicPlaceDtlData(dynamicTargetParam)

      if (!dynamicPlaceData || !dynamicPlaceData.list) {
        return
      }

      ;(dynamicPlaceData.list as ManagementPlaceMapData[]).forEach(item => {
        this.mapService.drawImage(item)
      })

      this.$log.debug('MAP > fetchMasterPlaceList: dynamicPlaceData=', dynamicPlaceData)
    } catch (e) {
      this.$log.debug('MAP > fetchMasterPlaceList: e=', e)
      throw e
    }
  }

  /**
   * 管理場所データ変換
   *
   * @param {ManagementPlaceMapData[]} dynamicPlaceList 管理場所データ
   * @returns {PlaceMasterItemForPage[]} 管理場所データ
   */
  formatPlaceList(dynamicPlaceList: ManagementPlaceMapData[]): PlaceMasterItemForPage[] {
    dynamicPlaceList.map(item => {
      item.businessOfficeCode = this.getDefinitionName(this.officeMasterData, item.businessOfficeId, {
        code: 'businessOfficeId',
        value: 'businessOfficeCode'
      })
      item.businessOfficeName = this.getDefinitionName(this.officeMasterData, item.businessOfficeId, {
        code: 'businessOfficeId',
        value: 'businessOfficeName'
      })
      item.areaName = this.getDefinitionName(this.areaAllocationMasterData, item.areaId, {
        code: 'id',
        value: 'areaName'
      })
      const PrefectureMaster = this.getPrefecturesByAreaId(item.areaId)
      item.prefectureName = this.getDefinitionName(PrefectureMaster, item.prefectureId, {
        code: 'id',
        value: 'prefectureName'
      })
    })
    const groupObject: Record<string, ManagementPlaceMapData[]> = groupBy(
      dynamicPlaceList,
      (item: ManagementPlaceMapData) => item.businessOfficeId
    )

    const resultArray = []
    for (let key in groupObject) {
      const object = {
        businessOfficeId: key,
        businessOfficeCode: groupObject[key][0]?.businessOfficeCode,
        businessOfficeName: groupObject[key][0]?.businessOfficeName,
        isShow: true,
        children: groupObject[key]
      }
      resultArray.push(object)
    }

    return resultArray
  }

  /**
   * 管理対象データ変換
   *
   * @param {ManagementItem[]} dynamicTargetList 管理対象データ
   * @param {UsageStatus} usageStatus 利用状況
   * @returns {ManagementItemForPage[]} 管理対象データ
   */
  formatTargetList(dynamicTargetList: ManagementItem[], usageStatus: UsageStatus): ManagementItemForPage[] {
    const filterData = filter(dynamicTargetList, (item: ManagementItem) => item.usageStatus === usageStatus)
    filterData.map(item => {
      item.deviceStatusName = this.getDefinitionName(this.operationStatusList, item.deviceStatus, {
        code: 'code',
        value: 'name'
      })

      item.powerSavingModeName = this.getDefinitionName(this.powerSavingModeList, item.powerSavingMode, {
        code: 'code',
        value: 'name'
      })
    })
    const groupObject: Record<string, ManagementItem[]> = groupBy(
      filterData,
      (item: ManagementItem) => item.businessOfficeId
    )

    const resultArray = []
    for (let key in groupObject) {
      const object = {
        businessOfficeId: key,
        businessOfficeCode: groupObject[key][0]?.businessOfficeCode,
        businessOfficeName: groupObject[key][0]?.businessOfficeName,
        isShow: true,
        children: groupObject[key]
      }
      resultArray.push(object)
    }

    return resultArray
  }

  /**
   * 営業所割当マスタを取得する
   *
   * @returns {void}
   */
  async fetchSalesOfficeAllocationMaster(): Promise<void> {
    try {
      const masters = await getSalesOfficeAllocationMasterData()
      this.officeMasterData = (masters.businessOfficeList as AllocationOfficeItem[]) || []
      this.formatPlaceListAfter(this.theDynamicPlaceList)
    } catch (e) {
      this.$log.debug('MAP > fetchSalesOfficeAllocationMaster: e=', e)
      throw e
    }
  }

  /**
   * キーワードをフィルタする
   */
  // eslint-disable-next-line
  onFilterValue(): void {
    // eslint-disable-next-line
    this.searchFormRef.validate((valid: boolean) => {
      if (!valid) return false
      if (this.tabType === TabType.CAR) {
        const filterValue = this.searchForm.filterObjectValue

        if (this.usageType === UsageStatus.IN_USE) {
          if (!this.searchForm.filterObjectValue) {
            this.managementForPage = cloneDeep(this.managementInUseData)
            this.thumDataForPage = cloneDeep(this.thumInUseData)
            return
          }

          this.managementInUseData.forEach((businessItem, index) => {
            this.managementForPage[index].children = businessItem.children.filter(item => {
              return item.manageTargetCode.indexOf(filterValue) > -1 || item.manageTargetName.indexOf(filterValue) > -1
            })
          })
          this.thumDataForPage = this.thumInUseData.filter(item => {
            return item.manageTargetCode.indexOf(filterValue) > -1 || item.manageTargetName.indexOf(filterValue) > -1
          })
        }

        if (this.usageType === UsageStatus.NO_USE) {
          if (!this.searchForm.filterObjectValue) {
            this.managementForPage = cloneDeep(this.managementNoUseData)
            this.thumDataForPage = cloneDeep(this.thumNoUseData)
            return
          }

          this.managementNoUseData.forEach((businessItem, index) => {
            this.managementForPage[index].children = businessItem.children.filter(item => {
              return item.manageTargetCode.indexOf(filterValue) > -1 || item.manageTargetName.indexOf(filterValue) > -1
            })
          })
          this.thumDataForPage = this.thumNoUseData.filter(item => {
            return item.manageTargetCode.indexOf(filterValue) > -1 || item.manageTargetName.indexOf(filterValue) > -1
          })
        }
      }

      if (this.tabType === TabType.PLACE) {
        if (!this.searchForm.filterPlaceValue) {
          this.placeForPage = cloneDeep(this.managementPlaceData)
          this.thumPlaceDataForPage = cloneDeep(this.thumPlaceData)
          return
        }

        const filterValue = this.searchForm.filterPlaceValue

        this.managementPlaceData.forEach((businessItem, index) => {
          this.placeForPage[index].children = businessItem.children.filter(item => {
            return item.managementPlaceName.indexOf(filterValue) > -1
          })
        })
        this.thumPlaceDataForPage = this.thumPlaceData.filter(item => {
          return item.managementPlaceName.indexOf(filterValue) > -1
        })
      }
    })
  }

  /**
   * 利用状況変化時の対応
   */
  onChangeUsage(): void {
    this.initManagementData()
    this.initSelected()
  }

  /**
   * 管理対象データを初期化する
   */
  initManagementData(): void {
    if (this.usageType === UsageStatus.IN_USE) {
      this.managementForPage = cloneDeep(this.managementInUseData)
      this.thumDataForPage = cloneDeep(this.thumInUseData)
    }

    if (this.usageType === UsageStatus.NO_USE) {
      this.managementForPage = cloneDeep(this.managementNoUseData)
      this.thumDataForPage = cloneDeep(this.thumNoUseData)
    }
  }

  /**
   * 管理場所データを初期化する
   *
   * @returns {void}
   */
  initManagementPlaceData(): void {
    this.placeForPage = cloneDeep(this.managementPlaceData)

    this.thumPlaceDataForPage = cloneDeep(this.thumPlaceData)
  }

  /**
   * エリア割当マスタを取得する
   *
   * @returns {void}
   */
  async fetchAreaAllocationMasterData(): Promise<void> {
    try {
      const master = await getAreaAllocationMasterData()
      this.areaAllocationMasterData = (master.areaList as AreaMasterData[]) || []
    } catch (e) {
      this.$log.debug('MST_MGMT_LOC > fetchAreaAllocationMasterData: e=', e)
      throw e
    }
  }

  /**
   * 都道府県リストを取得する処理
   *
   * @param {string} areaId エリアID
   * @returns {void}
   */
  getPrefecturesByAreaId(areaId: string): PrefectureMasterData[] {
    const area = this.areaAllocationMasterData.find(element => element.id === areaId)
    if (!area || !area.prefectureList) {
      return []
    }
    return area.prefectureList
  }

  /**
   * 緯度と経度の表示をフォーマットする
   *
   * @param {string} latlon 緯度と経度
   * @returns {string} 緯度と経度の表示
   */
  formatLatlonShow(latlon: string): string {
    if (!latlon) return '000.00.000'

    const latlonArr = latlon.split('.')
    if (!latlonArr || latlonArr.length === 0) return '000.00.000'

    let degStr = ''
    if (latlonArr[0].length === 1) {
      degStr = '00' + latlonArr[0]
    } else if (latlonArr[0].length === 2) {
      degStr = '0' + latlonArr[0]
    } else {
      degStr = latlonArr[0]
    }

    let minStr = ''
    if (!latlonArr[1]) {
      minStr = '00'
    } else if (latlonArr[1].length === 1) {
      minStr = '0' + latlonArr[1]
    } else {
      minStr = latlonArr[1]
    }

    let secStr = ''
    if (!latlonArr[2]) {
      secStr = '000'
    } else if (latlonArr[2].length > 3) {
      secStr = latlonArr[2].slice(0, 3)
    }

    return degStr + '.' + minStr + '.' + secStr
  }
}
</script>

<style scoped lang="scss">
.map-body {
  display: flex;
  width: 100%;
  height: 100%;
  font-size: $FS01;
}

.map-content {
  width: 100%;
  height: calc(100% - 40px);
}

.map-head {
  background: $C42;
  text-align: right;
  width: 100%;
  height: 40px;
  line-height: 40px;
  z-index: 1;
  box-shadow: 1px 1px 1.5px rgba(0, 0, 0, 0.5);
}

.zdc-map {
  width: 100%;
  height: 100%;
}

.map-slider {
  height: calc(100vh - 49px);
  z-index: 10;
  position: relative;
  display: flex;
  align-items: center;

  .map-left {
    width: 320px;
    height: 100%;
    border-right: 1px solid;
    transition: opacity 0.2s ease-in;
    background-color: $C01;
  }

  .map-right {
    width: 12px;
    height: 48px;
    cursor: pointer;
    position: absolute;
    background: $C02;
    color: $C09;
    box-shadow: 2px 2px 2px rgb(0 0 0 / 50%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -1px;
  }

  .icon-top {
    display: flex;
    padding: 13px 0 24px;

    .icon-left {
      margin-left: 64px;
    }

    .icon-right {
      margin-left: 56px;
    }

    .icon-lr {
      color: $C08;
      text-align: center;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      width: 68px;
      height: 68px;
      border: 1px solid $C10;
      border-radius: 34px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      .tab-icon {
        color: $C42;
      }

      .tab-title {
        font-size: $FS03;
        color: $C08;
      }
    }

    .beclick-icon {
      background: $C42;
      color: $C01;

      .tab-icon {
        color: $C01;
      }

      .tab-title {
        color: $C01;
      }
    }
  }

  .input {
    padding: 0 12px;
    margin-bottom: 24px;

    .displayTarget {
      color: $C07;
    }

    ::v-deep .el-radio__inner {
      width: $FS01;
      height: $FS01;
    }

    ::v-deep .el-radio__label {
      font-size: $FS01;
    }
  }

  .entry {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .tree {
    background: #fff;
    height: calc(calc(100vh - 48px) - 200px);
    overflow-y: scroll;
    color: $C08;

    .label-title {
      cursor: pointer;
      padding: 0 12px 5px 12px;
    }

    .tree-content {
      cursor: pointer;
      padding: 5px 12px;
      border-right: 3px solid $C01;

      &:hover {
        color: $C08;
        background: $C44;
      }

      .title {
        display: flex;
        justify-content: space-between;
      }
    }

    .tree-beChoosed {
      background: $C42;
      border-right: 3px solid $C45;

      div {
        color: $C01;
      }
    }
  }

  .tree-content:hover div {
    color: $C08;
  }

  .map-left-half {
    width: 48px;
    height: 100%;
    border-right: 1px solid;
    transition: opacity 0.2s ease-in;
    text-align: center;
    background-color: $C01;

    .icon-left-top {
      border-bottom: 1px solid #ccc;
      padding-bottom: 12px;

      .icon-t {
        background: $C04;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5px;
        cursor: pointer;
        color: $C42;
      }

      .beclick-icon-t {
        background: $C42;
        color: $C01;
      }
    }

    .halfTree-beChoosed {
      background: $C42 !important;

      div {
        color: $C01;
      }
    }

    .half-content {
      width: 40px;
      background: #e8e8e8;
      overflow: hidden;
      border-radius: 5px;
      margin: auto;
      margin-top: 5px;
      color: $C08;

      div {
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 10px;
        height: 13.3px;
        line-height: 13.3px;
        padding: 0 1px;
        text-align: center;
      }

      div:first-child {
        height: 26.6px;
      }
    }

    .tree-beChoosed:hover div {
      color: $C08;
    }

    .halfTree-beChoosed:hover div {
      color: $C08;
    }

    .half-content:hover {
      cursor: pointer;
      background: $C44;
    }
  }
}

.allWidth {
  width: 320px;
}

.thumbWidth {
  width: 48px;
}

.allMapRightLeft {
  left: 320px;
}

.thumbMapRightLeft {
  left: 48px;
}

.btn-none {
  background: none;
  padding: 0;
  margin: 0 12px;
}

.tti-usage {
  font-size: 12px;
}

.el-radio {
  margin-right: 24px !important;
}

.expander {
  margin-right: 6px;
  width: 24px;
  vertical-align: -3px;
}

.mb-24 {
  margin-bottom: 24px;
}

.mr-6 {
  margin-right: 6px;
}

.ml-6 {
  margin-left: 6px;
}
</style>
